module.exports = __webpack_public_path__ + "static/cureapp-tech-568d20da394df42d1c955e6abbe05f6f.png";